import { InjectionToken } from '@angular/core';
import { ModalService } from '../interfaces/modal-service';

export const MODAL_SERVICE = new InjectionToken<ModalService>('MODAL_SERVICE');
